export default {
  computed: {
    isMobile() {
      return window.MOBILE_VERSION
    },
  },
  mounted() {
    document.addEventListener('click', this.handlePaginationContainerClick)
  },
  methods: {
    handlePaginationContainerClick(event) {
      if (event.target.closest(this.domNodes.pagination)) {
        const url = event.target.closest('a')?.href

        if (url) {
          event.preventDefault()
          this.populatePageWithNewData(url)
        }
      }
    },
  },
}
